import loadable from '@loadable/component'
import React, { useState } from 'react'
import { ReactComponent as PrevIcon } from '@/assets/icons/prev.svg'
import { ReactComponent as NextIcon } from '@/assets/icons/next.svg'
import { Item } from '@/components/organisms/SectionCaseStudiesGrid/Item/Item'
import { SectionCaseStudiesGridItem } from '@/components/organisms/SectionCaseStudiesGrid/types'

const ReactPaginate = loadable(() => import('react-paginate'))

function PaginationComponent({ itemsPerPage, items }: { itemsPerPage: number; items: SectionCaseStudiesGridItem[] }) {
  const [itemOffset, setItemOffset] = useState<number>(0)
  if (!items || items.length === 0)
    return (
      <div className="text-center text-text-dark-600 text-bodyM">
        <p>No case studies found</p>
      </div>
    )

  const endOffset = itemOffset + +itemsPerPage
  const currentItems = items.slice(itemOffset, endOffset)
  const pageCount = Math.ceil(items.length / itemsPerPage)
  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * itemsPerPage) % items.length
    setItemOffset(newOffset)
    const scrollIntoElement = document.getElementById('grid')
    window.scrollTo({ top: scrollIntoElement ? scrollIntoElement.offsetTop - 50 : 0, behavior: 'smooth' })
  }

  const nextBtn = (
    <div className="size-24 [&>svg>path]:stroke-primary-700 [&>svg]:ml-auto">
      <NextIcon />
    </div>
  )
  const prevBtn = (
    <div className="size-24 [&>svg>path]:stroke-primary-700 [&>svg]:mr-auto">
      <PrevIcon />
    </div>
  )

  return (
    <div>
      <div id="grid" className="grid grid-cols-1 tablet:grid-cols-2 lg:grid-cols-3 gap-24 h-fit w-full">
        {currentItems && currentItems.map((item) => <Item item={item} key={item.id} />)}
      </div>
      <ReactPaginate
        pageCount={pageCount}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        breakLabel="..."
        renderOnZeroPageCount={null}
        nextLabel={nextBtn}
        previousLabel={prevBtn}
        className="flex gap-8 justify-center items-center mt-32 netbook:mt-64"
        pageClassName="font-bold w-32 h-32 text-text-brand-darker text-center flex justify-center items-center"
        activeClassName="bg-primary-900 text-white font-bold w-32 h-32 text-center rounded"
        disabledLinkClassName="[&>div>svg>path]:stroke-grey-700 cursor-not-allowed"
      />
    </div>
  )
}

export default PaginationComponent
